import { render, staticRenderFns } from "./PageToolbar.vue?vue&type=template&id=60b72dda&"
import script from "./PageToolbar.vue?vue&type=script&lang=js&"
export * from "./PageToolbar.vue?vue&type=script&lang=js&"
import style0 from "./PageToolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports